import * as React from 'react';

interface IProps {
  className?: string;
  width?: number;
  height?: number;
}

export const DefaultImg: React.FC<IProps> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill="none"
      viewBox="0 0 88 88"
      className={props.className}
      preserveAspectRatio="none"
      data-testid="DefaultImg"
    >
      <rect width="100%" height="100%" fill="#F4F4F4" rx="2" />
      <path
        fill="#C9C9C9"
        fillRule="evenodd"
        d="M30 32h28a2 2 0 012 2v20a2 2 0 01-2 2H30a2 2 0 01-2-2V34a2 2 0 012-2zm10.02 10.414l-.095.096 4.585 4.586 1.975-1.975.404.404.525-.525 9 9H58V34H30v15.607l7.096-7.097-.096-.096L38.414 41l.096.096.097-.096 1.414 1.414zM53.587 54l-6.576-6.575L40.435 54h13.15zM30 52.435l8.51-8.51 4.586 4.585L38 53.607l.393.393H30v-1.565zM50 44a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 110-4 2 2 0 010 4z"
        clipRule="evenodd"
      />
    </svg>
  );
};

DefaultImg.displayName = 'DefaultImg';
